<template>
    <div>
        <div class="d-md-flex justify-content-between align-items-end mb-4">
            <h2 class="mb-3 mb-md-0">
                Stel uw vraag over <br>
                fytosanitaire risico’s
            </h2>
            <a href="/vraagbaak" class="btn btn-link btn-caret btn-link-white btn-sm" v-if="path !== '/vraagbaak'">Naar
            de vraagbaak</a>
        </div>
        <div v-if="success" class="alert alert-info">{{ success }}</div>

        <form @submit.prevent="submit" novalidate>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group" :class="{'error-shake has-invalid': $v.form.subject.$error}">
                        <label for="category" class="control-label sr-only">Waar gaat uw vraag over</label>
                        <select name="status" id="category" class="custom-select" v-model.trim.lazy="$v.form.subject.$model">
                            <option selected disabled value="Waar gaat uw vraag over">Waar gaat uw vraag over</option>
                            <option v-for="(subject, index) in subjects" :value="subject.id" :key="index">{{ subject.onderwerp }}</option>
                        </select>
                        <small class="help-text" v-if="$v.form.subject.$error">
                            <template v-if="!$v.form.subject.minValue || !$v.form.subject.required">Dit veld is verplicht</template>
                        </small>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <div class="input-group input-group-file">
                            <div class="custom-file">
                                <input type="file" name="file" id="files"
                                       accept="application/pdf, application/msword, image/jpg, image/jpg"
                                       class="custom-file-input custom-select"
                                       @change="filesHandler">
                                <label for="files" data-content="Bestand kiezen" data-action="Bladeren"
                                       class="custom-file-label" v-html="fileLabel"></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group" :class="{'error-shake has-invalid': $v.form.question.$error}">
                        <label for="question" class="control-label sr-only">Stel uw vraag</label>
                        <textarea name="text" rows="10" cols="50" id="question" placeholder="Stel uw vraag"
                                  class="form-control" v-model.trim.lazy="$v.form.question.$model"
                                  @focus="$v.form.question.$reset"></textarea>
                        <small class="help-text" v-if="$v.form.question.$error">
                            <template v-if="!$v.form.question.required">Vraag is verplicht</template>
                            <template v-if="!$v.form.question.minLength">Vraag moet minimaal
                                {{ $v.form.question.$params.minLength.min }} letters zijn.</template>
                        </small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'error-shake has-invalid': $v.form.name.$error }">
                        <input type="text" name="name" id="name"
                               class="form-control" v-model.trim.lazy="$v.form.name.$model"
                               @focus="$v.form.name.$reset"
                               placeholder="Naam">
                        <small class="help-text" v-if="$v.form.name.$error">
                            <template v-if="!$v.form.name.required">Naam is verplicht</template>
                            <template v-if="!$v.form.name.minLength">Naam moet minimaal
                                {{ $v.form.name.$params.minLength.min }} letters zijn.</template>
                        </small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{'error-shake has-invalid': $v.form.email.$error}">
                        <label for="email" class="control-label sr-only">E-mailadres</label>
                        <input type="email" name="email" id="email" placeholder="E-mailadres" class="form-control"
                               v-model.trim.lazy="$v.form.email.$model" @focus="$v.form.email.$reset">
                        <small class="help-text" v-if="$v.form.email.$error">
                            <template v-if="!$v.form.email.required">E-mailadres is verplicht</template>
                            <template v-if="!$v.form.email.email">Geen geldig e-mailadres</template>
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group" :class="{'error-shake has-invalid': $v.form.tel.$error}">
                        <label for="phone" class="control-label sr-only">Telefoonnummer (Alleen als u telefonisch
                            antwoord wil op uw vraag)</label>
                        <input type="text" name="phone" id="phone"
                               placeholder="Telefoonnummer (Alleen als u telefonisch antwoord wil op uw vraag)"
                               class="form-control" v-model.trim.lazy="$v.form.tel.$model" @focus="$v.form.tel.$reset">
                        <small class="help-text" v-if="$v.form.tel.$error">
                            <template v-if="!$v.form.tel.minLength">Geen geldig telefoonnummer</template>
                        </small>
                    </div>
                </div>
            </div>
            <div class="d-md-flex justify-content-start align-items-center">
                <button type="submit" class="btn btn-btn btn-primary btn-caret btn-sm mr-4 mb-3 mb-md-0" ref="btn">Vraag verzenden</button>
                <div class="custom-control custom-checkbox" :class="{'error-shake has-invalid': $v.form.privacy.$error}">
                    <input type="checkbox" id="checkprivacy" class="custom-control-input"
                           v-model.trim.lazy="$v.form.privacy.$model">
                    <label for="checkprivacy" class="custom-control-label">Ik ga akkoord met het <a href="/privacy">Privacybeleid</a>
                        van Fytocompass</label>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {required, email, minLength, minValue} from 'vuelidate/lib/validators'
    import mustBeTrue from '../js/validators/mustBeTrue'

    export default {
        data() {
            return {
                path: '',
                processing: false,
                fileName: '',
                form: {
                    email: null,
                    name: null,
                    privacy: null,
                    question: null,
                    subject: 'Waar gaat uw vraag over',
                    tel: null,
                },
                subjects: [],
                success: '',
                data: null,
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(2),
                },
                question: {
                    required,
                    minLength: minLength(6),
                },
                email: {
                    required,
                    email,
                },
                privacy: {
                    mustBeTrue,
                },
                tel: {
                    minLength: minLength(6),
                },
                subject: {
                    required,
                    minValue: minValue(1),
                },
            }
        },
        computed: {
            fileLabel() {
                return this.fileName ? this.fileName : 'Upload een bestand <span class="d-lg-none">(.pdf, .doc(x), .jpg, .png)</span>';
            }
        },
        created() {
            this.axios.get('api/onderwerpen')
                .then(response => {
                    this.subjects = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        mounted() {
            this.path = window.location.pathname;
        },
        methods: {
            filesHandler(e) {
                this.data = new FormData();
                let files = e.target.files || e.dataTransfer.files;
                this.data.append('file', files[0]);
                this.fileName = files[0].name;
            },
            submit() {
                this.$refs.btn.blur();
                this.$v.$touch();

                if (!this.processing && this.$v.$anyDirty && !this.$v.$invalid) {
                    this.processing = true;

                    this.data = new FormData();

                    this.data.append('question', this.form.question);
                    this.data.append('name', this.form.name);
                    this.data.append('email', this.form.email);
                    if (this.form.tel) {
                        this.data.append('tel', this.form.tel);
                    }
                    this.data.append('subject', this.form.subject);

                    this.axios.post('vraagbaak', this.data)
                        .then(response => {
                            this.success = response.data.success;

                            this.$v.$reset();

                            this.form = {
                                email: null,
                                name: null,
                                privacy: null,
                                question: null,
                                subject: 'Waar gaat uw vraag over',
                                tel: null,
                            };
                        })
                        .catch(error => {
                            console.error(error);

                            this.$notify({
                                group: 'base',
                                text: 'Het vesturen van de vraag is mislukt. Probeer het later nog een keer.',
                                type: 'alert-danger',
                            });

                            this.$v.$touch();
                        })
                        .finally(() => {
                            this.processing = false;
                        });
                }
            }
        }
    }
</script>
